import { render, staticRenderFns } from "./DiagnosticBuilderTriggerEditorCard.vue?vue&type=template&id=1f8e64ba&scoped=true&"
import script from "./DiagnosticBuilderTriggerEditorCard.vue?vue&type=script&lang=js&"
export * from "./DiagnosticBuilderTriggerEditorCard.vue?vue&type=script&lang=js&"
import style0 from "./DiagnosticBuilderTriggerEditorCard.vue?vue&type=style&index=0&id=1f8e64ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8e64ba",
  null
  
)

export default component.exports